export default "__VITE_ASSET__D4gyKAI0__"